class KeyupBarcodeScanner extends React.Component {

    constructor(props) {
        super(props);

        this.keyup = this.keyup.bind(this);
        this.keydown = this.keydown.bind(this);
        this._inputString = '';
        this._timeoutHandler = null;
        this.pressed = {};
        this.translations = {
            8: '', //backspace
            10: '\n', //ENTER,
            13: '\r', //CR
            16: '', //shift
            17: '', //ctrl
            20: '', //caps lock
            27: '', //escape
            37: '', //left arrow
            38: '', //up arrow
            39: '', //right arrow
            40: '', //down arrow
            46: '', //delete
            192: '', //~
            220: '', //\
        }

        this.ignore = {
            37: true //ArrowLeft
            ,38: true //ArrowUp
            ,39: true //ArrowRight
            ,40: true //ArrowDown
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.keydown); 
        document.addEventListener('keyup', this.keyup); 
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keydown); 
        document.removeEventListener('keyup', this.keyup); 
    }

    keydown(e) {
        //apparently .which is deprecated so we need to cutover at some point

        this.pressed[e.which] = true;

        //17 = ctrl, 74 = j
        //prevents certain barcode readers from opening 
        //inspector (ctrl+shift+j) or downloads (ctrl+j) in Chrome.
        if(this.pressed[74] && this.pressed[17]){
            e.preventDefault();
        }
    }

    keyup(e) {
        delete this.pressed[e.which];
        if (this.ignore[e.which]) {
            return;
        }
        
        if (e.which === 74 && this.pressed[17]){
            this._inputString += '\n';            
            return;
        }
        
        if (this._timeoutHandler) {
            clearTimeout(this._timeoutHandler);
        }
        var char = e.key;
        if (e.which in this.translations) {
            char = this.translations[e.which];
        }
        this._inputString += char;

        this._timeoutHandler = setTimeout($.proxy(function () {
            if (this._inputString.length <= 3) {
                this._inputString = '';
                return;
            }

            this.props.onScan(this._inputString.trim(), true);

            this._inputString = '';
        }, this), 100);
    }

    render() {
        return null;
    }
}

export default KeyupBarcodeScanner;



// WEBPACK FOOTER //
// ./ui_src/app/components/scanner/KeyUpBarcodeScanner.react.jsx